import { Callout, useLocalStorage } from 'hooks/userPreferences';
import { env } from 'lib/constants/env';
import { HOME } from 'lib/constants/routes';
import { usePathname } from 'next/navigation';

export const useIsCalloutVisible = () => {
  const pathname = usePathname();
  const isHomePage = pathname === HOME;

  const { getValue } = useLocalStorage(Callout);

  if (!env.NEXT_PUBLIC_SITE_TOGGLE_CALLOUT_ENABLED || !isHomePage) {
    return false;
  }
  const hasBeenViewed = getValue();
  return !hasBeenViewed;
};
